import React, { useState, useEffect, useCallback, useRef } from "react";
import { RetellWebClient } from "retell-client-js-sdk";

const agentId = "agent_9be354d59e8aab00b8c9e88ae2";
const webClient = new RetellWebClient();

const categories = [
  "AI Girlfriend",
  "AI Boyfriend",
  "Supportive Friend",
  "Study Buddy",
  "Fitness Coach",
  "Career Mentor",
  "Therapist",
];

const companions = [
  {
    id: 1,
    name: "Catalina",
    age: 19,
    category: "AI Girlfriend",
    tagline: "Care to join me for a shower?",
    image:
      "https://www.shutterstock.com/image-photo/beautiful-young-redhead-woman-curly-600nw-2468773667.jpg",
    agentId: "agent_9be354d59e8aab00b8c9e88ae2",
  },
  {
    id: 2,
    name: "Rina",
    age: 23,
    category: "AI Girlfriend",
    tagline: "I could use some help over here...",
    image:
      "https://www.shutterstock.com/image-photo/photo-happy-attractive-lady-touch-600nw-2389651613.jpg",
    agentId: "agent_9be354d59e8aab00b8c9e88ae2",
  },
  {
    id: 3,
    name: "Grace",
    age: 23,
    category: "Supportive Friend",
    tagline: "Here to lend an ear and offer support!",
    image:
      "https://www.shutterstock.com/image-photo/highquality-closeup-asian-woman-glowing-600nw-2491853021.jpg",
  },
  {
    id: 4,
    name: "Natasha",
    age: 18,
    category: "Study Buddy",
    tagline: "Let's ace those exams together!",
    image:
      "https://img.freepik.com/premium-photo/students-with-many-books-suffering-from-pain-shoulder-having-made-effort_1368-39283.jpg?ga=GA1.1.1854890901.1725101209&semt=ais_hybrid",
  },
  {
    id: 5,
    name: "Alex",
    age: 25,
    category: "AI Boyfriend",
    tagline: "Ready for an adventure?",
    image:
      "https://www.shutterstock.com/image-photo/happy-young-man-taking-selfie-600nw-2462133657.jpg",
  },
  {
    id: 6,
    name: "Marcus",
    age: 28,
    category: "Fitness Coach",
    tagline: "Let's crush those fitness goals!",
    image:
      "https://www.shutterstock.com/image-photo/personal-trainer-showing-sportswoman-how-600nw-2399859383.jpg",
  },
  {
    id: 7,
    name: "Sophie",
    age: 26,
    category: "Career Mentor",
    tagline: "Your success is my priority",
    image:
      "https://www.shutterstock.com/image-photo/attractive-aged-businesswoman-teacher-mentor-600nw-1043108527.jpg",
  },
  {
    id: 8,
    name: "Yuki",
    age: 22,
    category: "Study Buddy",
    tagline: "こんにちは! Ready to practice?",
    image:
      "https://www.shutterstock.com/image-photo/female-friends-studying-cafe-600nw-2319762925.jpg",
  },
  {
    id: 9,
    name: "Bimal",
    age: 24,
    category: "Therapist",
    tagline: "I'm here to listen and help you heal",
    image:
      "https://www.shutterstock.com/image-photo/indian-male-doctor-consulting-senior-600nw-2036186195.jpg",
  },
  {
    id: 10,
    name: "Luna",
    age: 21,
    category: "Therapist",
    tagline: "We'll get through this together",
    image:
      "https://www.shutterstock.com/image-photo/young-male-sharing-personal-issues-600nw-2501942965.jpg",
  },
];

const AICompanionInterface = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("AI Girlfriend");
  const [selectedCompanion, setSelectedCompanion] = useState(null);
  const [isCalling, setIsCalling] = useState(false);
  const [callDuration, setCallDuration] = useState(0);
  const [transcript, setTranscript] = useState([]);
  const transcriptRef = useRef(null);

  const [lastProcessedUpdate, setLastProcessedUpdate] = useState(null);

  const updateTranscript = useCallback(
    (update) => {
      if (!update.transcript || update === lastProcessedUpdate) {
        return; // No new transcript or already processed this update
      }

      setTranscript(update.transcript);
      setLastProcessedUpdate(update);
    },
    [lastProcessedUpdate]
  );
  useEffect(() => {
    webClient.on("conversationStarted", () =>
      console.log("Conversation started")
    );
    webClient.on("conversationEnded", ({ code, reason }) => {
      console.log("Conversation ended:", code, reason);
      setIsCalling(false);
      setCallDuration(0);
    });
    webClient.on("error", (error) => {
      console.error("An error occurred:", error);
      setIsCalling(false);
      setCallDuration(0);
    });
    webClient.on("update", updateTranscript);

    return () => {
      webClient.off("update", updateTranscript);
    };
  }, [updateTranscript]);

  useEffect(() => {
    let interval;
    if (isCalling) {
      interval = setInterval(() => {
        setCallDuration((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isCalling]);

  useEffect(() => {
    if (transcriptRef.current) {
      transcriptRef.current.scrollTop = transcriptRef.current.scrollHeight;
    }
  }, [transcript]);

  const registerCall = async (agentId) => {
    try {
      const response = await fetch(
        "https://pythonbackendaichat-1.onrender.com/register-call-on-your-server",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ agent_id: agentId }),
        }
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      return await response.json();
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const startCall = async () => {
    try {
      const registerCallResponse = await registerCall(agentId);
      console.log("Register Call Response:", registerCallResponse);
      if (registerCallResponse.call_id) {
        await webClient.startConversation({
          callId: registerCallResponse.call_id,
          sampleRate: registerCallResponse.sampleRate,
          enableUpdate: true,
        });
        setIsCalling(true);
        setTranscript([]);
      }
    } catch (error) {
      console.error("Failed to start call:", error);
    }
  };

  const endCall = () => {
    webClient.stopConversation();
    setIsCalling(false);
    setCallDuration(0);
  };

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <div className="app-container">
      <aside className={`sidebar ${isDrawerOpen ? "open" : "closed"}`}>
        <div className="header-container">
          <div className="logo">
            {isDrawerOpen ? "Phonesonic / EmoConnect" : "S"}
          </div>
          <button
            className="drawer-toggle"
            onClick={() => setIsDrawerOpen(!isDrawerOpen)}
          >
            {isDrawerOpen ? "✖" : "☰"}
          </button>
        </div>
        <div className="nav-items">
          {categories.map((category) => (
            <button
              key={category}
              className={`nav-item ${
                selectedCategory === category ? "active" : ""
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </aside>
      <div className={`main-content ${isDrawerOpen ? "shifted" : ""}`}>
        <header className="header">
          <h1>{selectedCategory}</h1>
        </header>
        <div className="companion-grid">
          {companions
            .filter((companion) => companion.category === selectedCategory)
            .map((companion) => (
              <div
                key={companion.id}
                className="companion-card"
                onClick={() => setSelectedCompanion(companion)}
              >
                <img
                  className="companion-image"
                  src={companion.image}
                  alt={companion.name}
                />
                <div className="companion-info">
                  <h3>{companion.name}</h3>
                  <p>{companion.tagline}</p>
                </div>
              </div>
            ))}
        </div>
        {selectedCompanion && (
          <div className="companion-popup">
            <div className="companion-popup-content">
              <button
                className="close-button"
                onClick={() => setSelectedCompanion(null)}
              >
                &times;
              </button>
              <img
                className="popup-image"
                src={selectedCompanion.image}
                alt={selectedCompanion.name}
              />
              <h2>{selectedCompanion.name}</h2>
              <p>{selectedCompanion.tagline}</p>
              <button className="cta-button" onClick={startCall}>
                Start Call
              </button>
            </div>
          </div>
        )}
        {isCalling && (
          <div className="call-screen">
            <img
              className="call-image"
              src={selectedCompanion?.image}
              alt={selectedCompanion?.name}
            />
            <div className="call-duration">{formatDuration(callDuration)}</div>
            <button className="end-call-button" onClick={endCall}>
              End Call
            </button>
            <div className="transcript" ref={transcriptRef}>
              <h3>Transcript:</h3>
              <div className="chat-box">
                {transcript.map((message, index) => (
                  <div key={index} className={`chat-message ${message.role}`}>
                    <span className="chat-role">
                      {message.role === "agent"
                        ? `${selectedCompanion.name}:`
                        : "You:"}
                    </span>
                    <span className="chat-content">{message.content}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AICompanionInterface;
